import { Select, SelectProps } from 'antd';
import { InvoiceEmissionGoal } from '@/core/domain/invoice/invoices/invoices.enums';
import { useIntl } from 'react-intl';

const EmissionGoalSelect = ({ ...props }: SelectProps) => {
  const intl = useIntl();

  const emissionGoalOptions = [
    {
      value: InvoiceEmissionGoal.NFE_NORMAL,
      label: intl.formatMessage({
        id: 'invoice.domain.emissionGoals.normalNfe',
      }),
    },
    {
      value: InvoiceEmissionGoal.NFE_ADDITIONAL,
      label: intl.formatMessage({
        id: 'invoice.domain.emissionGoals.additionalNfe',
      }),
    },
    {
      value: InvoiceEmissionGoal.NFE_ADJUSTMENT,
      label: intl.formatMessage({
        id: 'invoice.domain.emissionGoals.adjustmentNfe',
      }),
    },
    {
      value: InvoiceEmissionGoal.NFE_MERCHANDISE_RETURN,
      label: intl.formatMessage({
        id: 'invoice.domain.emissionGoals.merchandiseReturnNfe',
      }),
    },
  ];

  return <Select {...props} allowClear options={emissionGoalOptions} />;
};

export default EmissionGoalSelect;
